const SEO_TITLE_MAX_LENGTH = 60;
const META_DESCRIPTION_MAX_LENGTH = 160;
const PRIMARY_KEYWORD_MAX_LENGTH = 100;
const OG_TITLE_MAX_LENGTH = 90;
const SECONDARY_KEYWORDS_MAX_COUNT = 5;

module.exports = {
  SEO_TITLE_MAX_LENGTH,
  META_DESCRIPTION_MAX_LENGTH,
  PRIMARY_KEYWORD_MAX_LENGTH,
  OG_TITLE_MAX_LENGTH,
  SECONDARY_KEYWORDS_MAX_COUNT,
};
